import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { translateValue } from '../utils';
function formatFilterValue(selected, filterConfig) {
    if (selected.length === filterConfig.values.length) {
        return 'All';
    }
    else if (!selected.length) {
        return React.createElement(Typography, { color: "text.disabled" }, "Select options");
    }
    return selected.map(function (value) { return translateValue(value, filterConfig); }).join(', ');
}
function renderSelectItems(filters, filterConfig) {
    var display = filterConfig.display, values = filterConfig.values;
    return (display.map(function (displayValue, index) { return (React.createElement(MenuItem, { key: displayValue, 
        // ts requires string | number, but component handles boolean well 
        value: values[index] },
        React.createElement(Checkbox, { checked: filters.indexOf(values[index]) > -1 }),
        React.createElement(ListItemText, { primary: displayValue }))); }));
}
export default function DataCatalogSyncTableHeadSelect(_a) {
    var colId = _a.colId, filters = _a.filters, onFilterClick = _a.onFilterClick, filterConfig = _a.filterConfig;
    return (React.createElement(Select, { multiple: true, value: filters, size: "small", variant: "standard", fullWidth: true, sx: { maxWidth: '120px' }, displayEmpty: true, onChange: function (event) { return onFilterClick(colId, event.target.value); }, renderValue: function (selected) { return formatFilterValue(selected, filterConfig); } }, renderSelectItems(filters, filterConfig)));
}
//# sourceMappingURL=DataCatalogSyncTableHeadSelect.js.map